import { Table, Button } from "reactstrap";
import React, { useState, useContext, useRef, useEffect } from "react";
import { AppContext } from '../application/provider';
import ModalEstadoPago from "../components/Modal/ModalEstadoPago";
import ModalEstadoPagoCargoPago from "../components/Modal/ModalEstadoPagoCargoPago";
import ModalReciboHonorariosCargoPago from "../components/Modal/ModalReciboHonorariosCargoPago";
import ModalRegistroCargoPago from "../components/Modal/ModalRegistroCargoPago";
import PlanillaService from "../axios_services/planilla.service";
import ArchivoService from "../axios_services/archivos.service";
import { FileMinus } from "lucide-react";
import Loader from "../components/Loader/Loader";
import ButtonUpdate from "../components/Buttons/ButtonUpdate";
import ButtonInsert from "../components/Buttons/ButtonInsert";
import { ButtonExcel, ButtonSearch } from '../components/Buttons/Buttons';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ButtonPdf from '../components/Buttons/ButtonPdf';
import "./CargoPago.css";

function CargoPago() {
    const [periodo_fecha, setPeriodoFecha] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    });
    const [periodo_consultado, setPeriodoConsultado] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    });
    const [periodo_pago, setPeriodoPago] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [usuarios, setUsuarios] = useState([]);
    const [cargo_pago, setCargoPago] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingDocumento, setLoadingDocumento] = useState({ usuarioId: null });
    const [state, setState] = useContext(AppContext);
    const isFirstRender = useRef(true);
    const [entidades_financieras] = useState(state.catalogos.tipos.filter(t => { return t.categoria_id == 25 }));
    const [estados_pago] = useState(state.catalogos.tipos.filter(t => { return t.categoria_id == 32 }));

    // Modal Estado de Pago RH (perfiles 21, 26)
    const [estadoPagoModal, setEstadoPagoModal] = useState(false);
    const [selectedItemEstado, setSelectedItemEstado] = useState(null);

    // Modal Recibo por Honorarios (perfiles 5, 8, 22)
    const [reciboModal, setReciboModal] = useState(false);
    const [selectedItemRecibo, setSelectedItemRecibo] = useState(null);

    // Modal Nuevo Registro Manual (perfiles 5, 8)
    const [modalRegistroManual, setModalRegistroManual] = useState(false);

    const userProfile = Number(state.user?.perfil_id);
    // Perfiles que pueden registrar Estado de Pago + Comprobante
    const canEstadoPago = [8, 21, 26].includes(userProfile);
    // Perfiles que pueden subir Recibo por Honorarios
    const canReciboHonorarios = [5, 8, 22, 26].includes(userProfile);
    // Perfiles que pueden agregar registros manualmente
    const canInsertManual = [5, 8, 22, 26].includes(userProfile);

    const meses = {
        '01': 'ENERO', '02': 'FEBRERO', '03': 'MARZO', '04': 'ABRIL',
        '05': 'MAYO', '06': 'JUNIO', '07': 'JULIO', '08': 'AGOSTO',
        '09': 'SETIEMBRE', '10': 'OCTUBRE', '11': 'NOVIEMBRE', '12': 'DICIEMBRE'
    };

    const getCargoPago = async () => {
        setLoading(true);
        try {
            const data = await PlanillaService.getCargoPago(periodo_fecha);

            // Fetch comprobantes de pago for the period
            const comprobantesData = await ArchivoService.getComprobantesPagoPeriodo(periodo_fecha).catch(() => []);
            const arrComprobantes = Array.isArray(comprobantesData) ? comprobantesData : (comprobantesData?.data || []);

            const enriched = (Array.isArray(data) ? data : []).map(cp => {
                const comp = arrComprobantes.find(c =>
                    Number(c.origen_id) === Number(cp.usuario_id)
                );
                return { ...cp, comprobante_url: comp ? comp.url_completa : null };
            });

            setCargoPago(enriched);
        } catch (error) {
            console.error('Error al obtener datos de planilla:', error);
            setCargoPago([]);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e, index, field) => {
        const val = field === 'fecha_pago' ? e.target.value : parseFloat(e.target.value) || 0;
        const newData = [...cargo_pago];
        newData[index][field] = val;

        // retencion y fecha_pago no afectan total_pagar (solo afectan el importe neto visual)
        if (field !== 'fecha_pago' && field !== 'retencion') {
            const row = newData[index];
            const produccion = parseFloat(row.total_produccion) || 0;
            const regularizar = parseFloat(row.monto_regularizar) || 0;
            const bono_anual = parseFloat(row.bono_anual) || 0;
            const extra = parseFloat(row.descuento_extra) || 0;
            const cancelado = parseFloat(row.descuento_cancelados) || 0;
            const observado = parseFloat(row.descuento_documento_observado) || 0;

            row.total_pagar = (produccion + regularizar + bono_anual) - (extra + cancelado + observado);
        }

        setCargoPago(newData);
    };

    const handleGuardarCambios = async () => {
        setLoading(true);
        try {
            const payload = {
                registros: cargo_pago.map(cp => ({
                    planilla_id: cp.planilla_id,
                    monto_regularizar: cp.monto_regularizar,
                    bono_anual: cp.bono_anual,
                    descuento_extra: cp.descuento_extra,
                    descuento_cancelados: cp.descuento_cancelados,
                    descuento_documento_observado: cp.descuento_documento_observado,
                    retencion: cp.retencion,
                    total_pagar: cp.total_pagar,
                    fecha_pago: cp.fecha_pago
                }))
            };
            await PlanillaService.actualizarCargoPagoManual(payload);
            alert("Cambios guardados correctamente.");
            await getCargoPago();
        } catch (error) {
            alert("Error al guardar cambios: " + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    const handleValidar = async () => {
        if (!window.confirm("¿Está seguro de validar/firmar los registros de este periodo?")) return;
        setLoading(true);
        try {
            await PlanillaService.validarCargoPagoNegocios(periodo_fecha, state.user.perfil_id, state.user.usuario_id);
            alert("Validación realizada correctamente.");
            await getCargoPago();
        } catch (error) {
            alert("Error al validar: " + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    const getStatusText = () => {
        if (cargo_pago.length === 0) return "";
        const first = cargo_pago[0];
        if (Number(first.aprobado_gg) > 0) return "APROBADO POR GERENCIA GENERAL";
        if (Number(first.aprobado_gn) > 0) return "VALIDADO POR GERENCIA DE NEGOCIOS";
        if (Number(first.aprobado_th) > 0) return "APROBADO POR TALENTO HUMANO";
        return "PENDIENTE DE VALIDACIÓN";
    };

    const isApprovalDisabled = () => {
        if (!state.user || cargo_pago.length === 0) return true;
        const perfil = Number(state.user.perfil_id);
        const first = cargo_pago[0];

        // TH: Perfiles 5, 8
        if ([5, 8].includes(perfil)) return Number(first.aprobado_th) > 0;
        // GN: Perfil 1 (Validado por Gerencia de Negocios)
        if (perfil === 1) return Number(first.aprobado_th) === 0 || Number(first.aprobado_gn) > 0;
        // GG: Perfil 9
        if (perfil === 9) return Number(first.aprobado_gn) === 0 || Number(first.aprobado_gg) > 0;

        return true;
    };

    const isExportEnabled = () => {
        if (cargo_pago.length === 0) return false;
        const first = cargo_pago[0];
        return Number(first.aprobado_th) > 0;
    };

    const canEditManualFields = () => {
        if (!state.user || cargo_pago.length === 0) return false;
        const perfil = Number(state.user.perfil_id);
        const first = cargo_pago[0];
        // Solo TH puede editar montos antes de aprobar
        return [5, 8].includes(perfil) && Number(first.aprobado_th) === 0;
    };



    const getRowClass = (cp) => {
        if (Number(cp.aprobado_gg) > 0) return 'row-validado';
        if (Number(cp.aprobado_gn) > 0 || Number(cp.aprobado_th) > 0) return 'row-validado'; // Matching logic where any validation level counts as validated
        return 'row-registrado';
    };

    const formatoSoles = (valor) => {
        return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(valor || 0);
    };

    // IMPORTE NETO = produccion + regularizar - descuentos - retencion (siempre calculado desde campos individuales)
    const getImporteNeto = (cp) => {
        const produccion = parseFloat(cp.total_produccion) || 0;
        const regularizar = parseFloat(cp.monto_regularizar) || 0;
        const bono_anual = parseFloat(cp.bono_anual) || 0;
        const extra = parseFloat(cp.descuento_extra) || 0;
        const cancelado = parseFloat(cp.descuento_cancelados) || 0;
        const observado = parseFloat(cp.descuento_documento_observado) || 0;
        const retencion = parseFloat(cp.retencion) || 0;
        return (produccion + regularizar + bono_anual) - (extra + cancelado + observado) - retencion;
    };

    const totalImporteNeto = cargo_pago.reduce((acc, cp) => acc + getImporteNeto(cp), 0);

    const handleButtonClick = async () => {
        setPeriodoConsultado(periodo_fecha);
        await getCargoPago();
    };

    const handleVerReciboHonorarios = async (usuario_id, periodo_fecha) => {
        try {
            const recibo_honorarios = await ArchivoService.getReciboPorHonorarios(usuario_id, periodo_fecha);
            window.open(recibo_honorarios.url_completa, "_blank", "noopener,noreferrer");
        } catch (error) {
            console.error("Error trayendo recibo por honorarios:", error);
            alert("Hubo un error al cargar el recibo por honorarios.");
        }
    };

    const mostrarModalEstadoPago = (cargo_pago) => {
        setState({
            ...state,
            modalEstadoPago: true,
            cargo_pago: cargo_pago,
            isUpdated: false
        });
    };



    const getNombreMesActual = () => {
        const [year, month] = periodo_consultado.split('-');
        return meses[month] || '';
    };

    const getNombreMesAnterior = () => {
        const [year, month] = periodo_consultado.split('-');
        const mesNum = parseInt(month);
        const mesAnterior = mesNum === 1 ? 12 : mesNum - 1;
        const mesPadded = String(mesAnterior).padStart(2, '0');
        return meses[mesPadded] || '';
    };

    const getNombreMesSiguiente = () => {
        const [year, month] = periodo_consultado.split('-');
        const mesNum = parseInt(month);
        const mesSiguiente = mesNum === 12 ? 1 : mesNum + 1;
        const mesPadded = String(mesSiguiente).padStart(2, '0');
        return meses[mesPadded] || '';
    };

    const exportToPDF = async () => {
        const doc = new jsPDF('landscape', 'pt', 'a4');
        const getMonthNameFull = (YYYY_MM) => {
            if (!YYYY_MM) return '';
            const [y, m] = YYYY_MM.split('-');
            const date = new Date(Number(y), Number(m) - 1, 1);
            return date.toLocaleString('es-PE', { month: 'long', year: 'numeric' }).toUpperCase();
        };
        const monthYearStr = getMonthNameFull(periodo_fecha);

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("MEC BUSINNES PARTNER S.A.C.", 28, 30);
        doc.text("20612796484", 28, 45);

        const tableColumnNames = [
            "N°", "APELLIDOS Y NOMBRES", "CARGO",
            "PAGOS POR PRODUCCIÓN " + getNombreMesActual(),
            "MONTO A REGULARIZAR MESES ANTERIORES", "BONO ANUAL",
            { content: "DESC. EXTRA", styles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] } },
            "DESC. CANCELADO", "DESCUENTO POR DOC. OBSERVADO",
            "RxH", "RETENCIÓN",
            { content: "IMPORTE NETO A PAGAR", styles: { fillColor: [255, 255, 0], textColor: [0, 0, 0] } },
            "N° DNI", "N° CUENTA", "N° C.I.", "ENTIDAD BANCARIA", "ESTADO", "FECHA PAGO"
        ];

        const formatNumberPdf = (val) => {
            if (val === 0 || !val) return "S/ -";
            return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', minimumFractionDigits: 2 }).format(val);
        };

        const tableRows = cargo_pago.map((cp, index) => [
            index + 1,
            cp.gestor?.toUpperCase(),
            cp.perfil?.toUpperCase(),
            formatNumberPdf(cp.total_produccion),
            formatNumberPdf(cp.monto_regularizar),
            formatNumberPdf(cp.bono_anual),
            formatNumberPdf(cp.descuento_extra),
            formatNumberPdf(cp.descuento_cancelados),
            formatNumberPdf(cp.descuento_documento_observado),
            "E001-",
            formatNumberPdf(cp.retencion),
            { content: formatNumberPdf(getImporteNeto(cp)), styles: { fillColor: [255, 255, 204], textColor: [0, 0, 0], fontStyle: 'bold' } },
            cp.dni,
            cp.n_cuenta_bancaria || "N/A",
            cp.n_cuenta_interbancaria || "N/A",
            entidades_financieras.find((item) => item.tipo_id === cp.entidad_financiera_id)?.descripcion || "N/A",
            "ACTIVO",
            cp.fecha_pago || ""
        ]);

        const totalRow = Array(18).fill("");
        totalRow[11] = formatNumberPdf(totalImporteNeto);
        tableRows.push(totalRow);

        autoTable(doc, {
            startY: 60,
            head: [
                [{
                    content: `CARGO DE PAGO - PRODUCCIÓN ${monthYearStr}`,
                    colSpan: 18,
                    styles: { halign: 'center', fillColor: [146, 208, 80], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 9, lineColor: [0, 0, 0], lineWidth: 0.5 }
                }],
                tableColumnNames
            ],
            body: tableRows,
            theme: 'grid',
            styles: { fontSize: 5, cellPadding: 1.5, overflow: 'linebreak', halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.5 },
            margin: { left: 20, right: 20 },
            headStyles: { fillColor: [255, 192, 0], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 5, lineColor: [0, 0, 0], lineWidth: 0.5 },
            didParseCell: function (data) {
                if (data.section === 'body' && data.row.index === tableRows.length - 1) {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.fillColor = [255, 255, 255];
                }
            }
        });

        const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 100;
        let startY = finalY + 80;
        if (startY > doc.internal.pageSize.height - 70) { doc.addPage(); startY = 70; }

        try {
            const first = cargo_pago[0];
            const thId = first.aprobado_th > 0 ? first.aprobado_th : null;
            const ggId = first.aprobado_gg > 0 ? first.aprobado_gg : null;
            const gnId = first.aprobado_gn > 0 ? first.aprobado_gn : null;

            const [firmaThRes, firmaGgRes, firmaSaRes] = await Promise.all([
                thId ? ArchivoService.getFirmaDigitalConvenio(thId).catch(() => null) : null,
                ggId ? ArchivoService.getFirmaDigitalConvenio(ggId).catch(() => null) : null,
                gnId ? ArchivoService.getFirmaDigitalConvenio(gnId).catch(() => null) : null
            ]);
            const firmaThB64 = firmaThRes?.base64 || null;
            const firmaGgB64 = firmaGgRes?.base64 || null;
            const firmaSaB64 = firmaSaRes?.base64 || null;
            const pageWidth = doc.internal.pageSize.width;
            const center1 = pageWidth * 0.25; const center2 = pageWidth * 0.50; const center3 = pageWidth * 0.75;

            doc.setFontSize(7);
            const drawSignature = (b64, name, role, cx, y) => {
                if (b64) {
                    const format = b64.includes('image/jpeg') || b64.includes('image/jpg') || b64.includes('data:image/jpeg') ? 'JPEG' : 'PNG';
                    doc.addImage(b64, format, cx - 50, y - 50, 100, 50);
                }
                doc.setLineWidth(0.5);
                doc.line(cx - 75, y, cx + 75, y);
                doc.setFont("helvetica", "bold"); doc.text(role, cx, y + 12, { align: 'center' });
                doc.setFont("helvetica", "normal"); doc.text(name, cx, y + 22, { align: 'center' });
            };

            const thName = first.nombre_aprobado_th ? first.nombre_aprobado_th.toUpperCase() : "JEFE DE TALENTO HUMANO";
            const gnName = first.nombre_aprobado_gn ? first.nombre_aprobado_gn.toUpperCase() : "GERENTE DE NEGOCIOS";
            const ggName = first.nombre_aprobado_gg ? first.nombre_aprobado_gg.toUpperCase() : "GERENTE GENERAL";

            if (ggId) drawSignature(firmaGgB64, ggName, "GERENTE GENERAL", center1, startY);
            if (gnId) drawSignature(firmaSaB64, gnName, "GERENTE DE NEGOCIOS", center2, startY);
            if (thId) drawSignature(firmaThB64, thName, "JEFE DE TALENTO HUMANO", center3, startY);
        } catch (e) { console.error("Error drawing signatures:", e); }

        doc.save(`CargoPago_${monthYearStr.replace(' ', '_')}.pdf`);
    };

    const exportarAExcel = async () => {
        if (cargo_pago.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Cargo de Pago');

        const [year, month] = periodo_fecha.split('-');
        const mesActual = meses[month];
        const mesAnterior = getNombreMesAnterior();
        const mesSiguiente = getNombreMesSiguiente();

        worksheet.mergeCells('A1:S1');
        const empresaCell = worksheet.getCell('A1');
        empresaCell.value = 'MEC BUSINNES PARTNER S.A.C.';
        empresaCell.font = { name: 'Calibri', size: 14, bold: true };
        empresaCell.alignment = { vertical: 'middle', horizontal: 'left' };
        empresaCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        };

        worksheet.mergeCells('A2:S2');
        const rucCell = worksheet.getCell('A2');
        rucCell.value = '20612796484';
        rucCell.font = { name: 'Calibri', size: 12, bold: true };
        rucCell.alignment = { vertical: 'middle', horizontal: 'left' };
        rucCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        };

        worksheet.mergeCells('A3:S3');
        const tituloCell = worksheet.getCell('A3');
        tituloCell.value = `CARGO DE PAGO - PRODUCCIÓN ${mesActual} ${year}`;
        tituloCell.font = { name: 'Calibri', size: 12, bold: true, color: { argb: 'FF000000' } };
        tituloCell.alignment = { vertical: 'middle', horizontal: 'center' };
        tituloCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF92D050' }
        };
        tituloCell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };
        worksheet.getRow(3).height = 25;

        const headers = [
            'N°',
            'APELLIDOS Y NOMBRES',
            'CARGO',
            'PAGOS POR PRODUCCIÓN ' + mesActual,
            'MONTO A REGULARIZAR MESES ANTERIORES',
            'BONO ANUAL',
            'DESC. EXTRA',
            'DESC. CANCELADO',
            'DESCUENTO POR DOC. OBSERVADO',
            'RxH',
            'RETENCIÓN',
            'IMPORTE NETO A PAGAR',
            'N° DNI',
            'N° CUENTA',
            'N° CUENTA INTERBANCARIA',
            'ENTIDAD BANCARIA',
            'ESTADO',
            'FECHA DE CESE',
            'FECHA DE PAGO'
        ];

        worksheet.getRow(4).values = headers;

        const headerRow = worksheet.getRow(4);
        headerRow.font = { name: 'Calibri', size: 11, bold: true };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        headerRow.height = 30;

        const headerColors = {
            'A4': 'FFFFC000',
            'B4': 'FFFFC000',
            'C4': 'FFFFC000',
            'D4': 'FFCC99FF',
            'E4': 'FFFF0000',
            'F4': 'FFFF0000',
            'G4': 'FFFF0000',
            'H4': 'FFFF0000',
            'I4': 'FFFF0000',
            'J4': 'FFFFC000',
            'K4': 'FFFFC000',
            'L4': 'FFFFFF00',
            'M4': 'FFFFC000',
            'N4': 'FFFFC000',
            'O4': 'FFFFC000',
            'P4': 'FFFFC000',
            'Q4': 'FFFFC000',
            'R4': 'FFFFC000',
            'S4': 'FFFF99CC'
        };

        headerRow.eachCell((cell, colNumber) => {
            const cellAddress = cell.address;

            if (['E4', 'F4', 'G4', 'H4', 'I4'].includes(cellAddress)) {
                cell.font = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
            } else {
                cell.font = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FF000000' } };
            }

            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: headerColors[cellAddress] || 'FFFFC000' }
            };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            };
        });

        cargo_pago.forEach((cp, index) => {
            const importeNeto = getImporteNeto(cp);
            const retencion = parseFloat(cp.retencion) || 0;
            const row = worksheet.addRow([
                index + 1,
                cp.gestor?.toUpperCase(),
                cp.perfil,
                parseFloat(cp.total_produccion) || 0,
                parseFloat(cp.monto_regularizar) || 0,
                parseFloat(cp.bono_anual) || 0,
                parseFloat(cp.descuento_extra) || 0,
                parseFloat(cp.descuento_cancelados) || 0,
                parseFloat(cp.descuento_documento_observado) || 0,
                'E001-',
                retencion,         // col 11 - RETENCIÓN
                importeNeto,       // col 12 - IMPORTE NETO
                cp.dni,
                cp.n_cuenta_bancaria || 'N/A',
                cp.n_cuenta_interbancaria || 'N/A',
                entidades_financieras.find((item) => item.tipo_id === cp.entidad_financiera_id)?.descripcion || 'N/A',
                'ACTIVO',
                '',
                cp.fecha_pago || ''
            ]);

            // IMPORTE NETO - fondo amarillo claro
            const importeCell = row.getCell(12);
            importeCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF99' } };

            // RETENCIÓN - texto naranja si hay retención
            if (retencion > 0) {
                row.getCell(11).font = { name: 'Calibri', size: 11, color: { argb: 'FFEA580C' }, bold: true };
            }

            // Descuentos en rojo
            [6, 7, 8].forEach(colNum => {
                const cell = row.getCell(colNum);
                cell.font = { name: 'Calibri', size: 11, color: { argb: 'FF000000' } };
            });
        });

        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber <= 4) return;

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                };

                if ([4, 5, 6, 7, 8, 9, 11, 12].includes(colNumber)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '"S/ "#,##0.00';
                } else if (colNumber === 2) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
            });
        });

        const lastDataRow = 4 + cargo_pago.length;
        const totalRow = worksheet.getRow(lastDataRow + 1);

        totalRow.getCell(1).value = '';
        totalRow.getCell(2).value = '';
        totalRow.getCell(3).value = '';

        totalRow.getCell(4).value = { formula: `SUM(D5:D${lastDataRow})` };
        totalRow.getCell(5).value = { formula: `SUM(E5:E${lastDataRow})` };
        totalRow.getCell(6).value = { formula: `SUM(F5:F${lastDataRow})` };
        totalRow.getCell(7).value = { formula: `SUM(G5:G${lastDataRow})` };
        totalRow.getCell(8).value = { formula: `SUM(H5:H${lastDataRow})` };
        totalRow.getCell(9).value = { formula: `SUM(I5:I${lastDataRow})` };
        totalRow.getCell(11).value = { formula: `SUM(K5:K${lastDataRow})` }; // RETENCIÓN
        totalRow.getCell(12).value = { formula: `SUM(L5:L${lastDataRow})` }; // IMPORTE NETO

        totalRow.font = { name: 'Calibri', size: 11, bold: true };
        totalRow.height = 20;

        [4, 5, 6, 7, 8, 9, 11, 12].forEach(colNum => {
            const cell = totalRow.getCell(colNum);
            cell.numFmt = '"S/ "#,##0.00';
            cell.alignment = { vertical: 'middle', horizontal: 'right' };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            };

            if ([7, 8, 9].includes(colNum)) {
                cell.font = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFF0000' } };
            }
        });

        worksheet.columns = [
            { width: 5 },
            { width: 35 },
            { width: 22 },
            { width: 20 }, // PAGOS POR PRODUCCIÓN
            { width: 18 }, // MONTO A REGULARIZAR
            { width: 18 }, // BONO ANUAL
            { width: 18 }, // DESC. EXTRA
            { width: 18 }, // DESC. CANCELADO
            { width: 18 }, // DESC. DOC. OBSERVADO
            { width: 15 }, // RxH
            { width: 18 }, // RETENCIÓN
            { width: 20 }, // IMPORTE NETO A PAGAR
            { width: 12 }, // DNI
            { width: 20 }, // Nº CUENTA
            { width: 25 }, // Nº CUENTA INTERBANCARIA
            { width: 25 }, // ENTIDAD
            { width: 12 }, // ESTADO
            { width: 15 }, // FECHA CESE
            { width: 15 }  // FECHA PAGO
        ];

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const nombreArchivo = `CargoPago_${mesActual}_${year}.xlsx`;
        saveAs(blob, nombreArchivo);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            await getCargoPago();
            setLoading(false);
            if (state.isUpdated) {
                setState(prevState => ({
                    ...prevState,
                    isUpdated: false,
                }));
            }
        };

        fetchData();
    }, [state.isUpdated]);

    return (
        <div className="cargo-pago-module">
            {loading ? (
                <Loader />
            ) :
                (<>
                    <div className="flex items-center justify-between mb-4">
                        <h1>RECIBO POR HONORARIOS - NEGOCIOS</h1>
                        <div className="flex gap-2">
                            <ButtonPdf
                                onClick={exportToPDF}
                                disabled={!isExportEnabled()}
                            />
                            <ButtonExcel
                                onClick={exportarAExcel}
                                disabled={cargo_pago.length === 0}
                            />
                        </div>
                    </div>
                    <div className="filtros">
                        <div>
                            <label htmlFor="periodo_fecha">Periodo de fecha:</label>
                            <input
                                id="periodo_fecha"
                                type="month"
                                value={periodo_fecha}
                                onChange={(e) => setPeriodoFecha(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 mb-4">
                        <div className="flex flex-col gap-3">
                            <div className="w-full">
                                <ButtonSearch onClick={handleButtonClick} isLoading={loading} />
                            </div>
                            <div className="flex justify-between items-center w-full">
                                <div className="flex items-center gap-4">
                                    {cargo_pago.length > 0 && (
                                        <div style={{
                                            backgroundColor: '#f5f5f5',
                                            padding: '10px 20px',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <span className="text-sm text-gray-700 uppercase tracking-wider" style={{ fontWeight: '400' }}>
                                                {getStatusText()}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-center gap-3">
                                    {canEditManualFields() && (
                                        <Button
                                            className="bg-blue-600 hover:bg-blue-700 text-white border-none text-[13px] px-4 py-2"
                                            onClick={handleGuardarCambios}
                                        >
                                            Guardar Cambios
                                        </Button>
                                    )}
                                    {cargo_pago.length > 0 && (
                                        <Button
                                            className={`px-4 py-2 rounded-lg text-xs font-semibold ${isApprovalDisabled()
                                                ? "bg-[#0b4d17] text-white opacity-95 cursor-not-allowed border-none shadow-none"
                                                : "bg-green-600 hover:bg-green-700 text-white border-none"
                                                }`}
                                            onClick={handleValidar}
                                            disabled={isApprovalDisabled()}
                                        >
                                            Aprobar y firmar
                                        </Button>
                                    )}
                                    {canInsertManual && (
                                        <ButtonInsert onClick={() => setModalRegistroManual(true)} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <div className="cargando">Cargando...</div>
                    ) : (
                        <div className="table-container">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>N°</th>
                                        <th className="min-w-[250px]">APELLIDOS Y NOMBRES</th>
                                        <th className="min-w-[220px]">CARGO</th>
                                        <th className="min-w-[130px]">PAGOS POR PRODUCCIÓN {getNombreMesActual()}</th>
                                        <th className="min-w-[160px]">MONTO A REGULARIZAR MESES ANTERIORES</th>
                                        <th className="min-w-[120px]">BONO ANUAL</th>
                                        <th className="min-w-[120px]">DESC. EXTRA</th>
                                        <th className="min-w-[120px]">DESC. CANCELADO</th>
                                        <th className="min-w-[170px] whitespace-normal">DESC. POR DOCUMENTO<br />OBSERVADO</th>
                                        <th className="min-w-[130px]">RETENCIÓN</th>
                                        <th className="min-w-[140px]">IMPORTE NETO A PAGAR</th>
                                        <th>N° DNI</th>
                                        <th className="min-w-[150px]">N° CUENTA</th>
                                        <th className="min-w-[180px]">N° CUENTA INTERBANCARIA</th>
                                        <th className="min-w-[150px]">ENTIDAD BANCARIA</th>
                                        <th>ESTADO</th>
                                        <th className="min-w-[110px] whitespace-normal">FECHA DE<br />CESE</th>
                                        <th className="text-center min-w-[120px]">RECIBO POR<br />HONORARIOS</th>
                                        <th className="min-w-[160px]">ESTADO DE PAGO</th>
                                        <th className="min-w-[150px]">FECHA DE PAGO</th>
                                        <th className="text-center min-w-[130px]">COMPROBANTE<br />DE PAGO</th>
                                        {(canEstadoPago || canReciboHonorarios) && (
                                            <th className="text-center">ACCIONES</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {cargo_pago.length > 0
                                        ? (cargo_pago
                                            .map((cp, i) => {
                                                return (
                                                    <tr key={cp.planilla_id} className={`align-middle ${getRowClass(cp)}`}>
                                                        <td className="text-center">{i + 1}</td>
                                                        <td className="py-1">{cp.gestor?.toUpperCase()}</td>
                                                        <td className="py-1">{cp.perfil}</td>
                                                        <td className="text-center">{formatoSoles(cp.total_produccion)}</td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input type="number" step="0.01" value={Number(cp.monto_regularizar || 0) === 0 ? "0.00" : cp.monto_regularizar} onChange={(e) => handleInputChange(e, i, 'monto_regularizar')} className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px]" />
                                                                </div>
                                                            ) : (
                                                                <span>{formatoSoles(cp.monto_regularizar)}</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input type="number" step="0.01" value={Number(cp.bono_anual || 0) === 0 ? "0.00" : cp.bono_anual} onChange={(e) => handleInputChange(e, i, 'bono_anual')} className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px]" />
                                                                </div>
                                                            ) : (
                                                                <span>{formatoSoles(cp.bono_anual)}</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input type="number" step="0.01" value={Number(cp.descuento_extra || 0) === 0 ? "0.00" : cp.descuento_extra} onChange={(e) => handleInputChange(e, i, 'descuento_extra')} className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px]" />
                                                                </div>
                                                            ) : (
                                                                <span>{formatoSoles(cp.descuento_extra)}</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input type="number" step="0.01" value={Number(cp.descuento_cancelados || 0) === 0 ? "0.00" : cp.descuento_cancelados} onChange={(e) => handleInputChange(e, i, 'descuento_cancelados')} className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px]" />
                                                                </div>
                                                            ) : (
                                                                <span>{formatoSoles(cp.descuento_cancelados)}</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input type="number" step="0.01" value={Number(cp.descuento_documento_observado || 0) === 0 ? "0.00" : cp.descuento_documento_observado} onChange={(e) => handleInputChange(e, i, 'descuento_documento_observado')} className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px]" />
                                                                </div>
                                                            ) : (
                                                                <span>{formatoSoles(cp.descuento_documento_observado)}</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {canEditManualFields() ? (
                                                                <div className="flex items-center justify-center gap-1">
                                                                    <span className="text-[11px] text-gray-500">S/</span>
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        value={Number(cp.retencion || 0) === 0 ? "0.00" : cp.retencion}
                                                                        onChange={(e) => handleInputChange(e, i, 'retencion')}
                                                                        className="form-control form-control-sm text-center h-7 px-1 w-20 text-[11px] text-orange-600 font-semibold"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <span className={parseFloat(cp.retencion) > 0 ? "text-orange-600 font-semibold" : ""}>
                                                                    {parseFloat(cp.retencion) > 0 ? formatoSoles(cp.retencion) : '—'}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="text-center" style={{ backgroundColor: '#feffc0' }}>
                                                            {formatoSoles(getImporteNeto(cp))}
                                                        </td>
                                                        <td className="text-center">{cp.dni}</td>
                                                        <td className="text-center">{cp.n_cuenta_bancaria ? cp.n_cuenta_bancaria : 'N/A'}</td>
                                                        <td className="text-center">{cp.n_cuenta_interbancaria ? cp.n_cuenta_interbancaria : 'N/A'}</td>
                                                        <td className="text-center">
                                                            {entidades_financieras.find((item) => item.tipo_id === cp.entidad_financiera_id)
                                                                ? entidades_financieras.find((item) => item.tipo_id === cp.entidad_financiera_id).descripcion
                                                                : "N/A"}
                                                        </td>
                                                        <td className="text-center">ACTIVO</td>
                                                        <td className="text-center">{cp.fecha_cese || '—'}</td>
                                                        {/* RECIBO POR HONORARIOS - izquierdo de FECHA DE PAGO */}
                                                        <td className="text-center">
                                                            <div className="flex justify-center items-center w-full">
                                                                {cp.tiene_recibo_honorarios === '1' ? (
                                                                    <button
                                                                        onClick={() => handleVerReciboHonorarios(cp.usuario_id, periodo_fecha)}
                                                                        className="bg-transparent border-0 p-0 hover:opacity-80 transition-opacity"
                                                                        title="Ver Recibo por Honorarios"
                                                                    >
                                                                        <FileMinus size={20} style={{ color: '#3cb167' }} />
                                                                    </button>
                                                                ) : (
                                                                    <FileMinus size={20} style={{ color: '#f87171', opacity: 0.5 }} title="Sin recibo disponible" />
                                                                )}
                                                            </div>
                                                        </td>
                                                        {/* ESTADO DE PAGO */}
                                                        <td className="text-center">
                                                            {estados_pago.find(item => item.tipo_id === cp.estado_pago_id)
                                                                ? estados_pago.find(item => item.tipo_id === cp.estado_pago_id).descripcion
                                                                : 'N/A'}
                                                        </td>
                                                        {/* FECHA DE PAGO */}
                                                        <td className="text-center">
                                                            <span>{cp.fecha_pago || '—'}</span>
                                                        </td>
                                                        {/* COMPROBANTE DE PAGO */}
                                                        <td className="text-center">
                                                            <div className="flex justify-center items-center w-full">
                                                                {cp.comprobante_url ? (
                                                                    <button
                                                                        onClick={() => window.open(cp.comprobante_url, '_blank')}
                                                                        className="bg-transparent border-0 p-0 hover:opacity-80 transition-opacity"
                                                                        title="Ver Comprobante de Pago"
                                                                    >
                                                                        <FileMinus size={20} style={{ color: '#3cb167' }} />
                                                                    </button>
                                                                ) : (
                                                                    <FileMinus size={20} style={{ color: '#f87171', opacity: 0.5 }} title="Sin comprobante disponible" />
                                                                )}
                                                            </div>
                                                        </td>
                                                        {/* ACCIONES: por perfil */}
                                                        {(canEstadoPago || canReciboHonorarios) && (
                                                            <td>
                                                                <div className="flex justify-center items-center gap-1">
                                                                    {/* Perfil 5, 8, 22 → Recibo por Honorarios */}
                                                                    {canReciboHonorarios && (
                                                                        <ButtonUpdate
                                                                            onClick={() => { setSelectedItemRecibo(cp); setReciboModal(true); }}
                                                                            title="Subir Recibo por Honorarios"
                                                                        />
                                                                    )}
                                                                    {/* Perfil 8, 21, 26 → Estado de Pago */}
                                                                    {canEstadoPago && (
                                                                        <ButtonUpdate
                                                                            onClick={() => { setSelectedItemEstado(cp); setEstadoPagoModal(true); }}
                                                                            title="Registrar Estado de Pago"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                );
                                            }))
                                        : (
                                            <tr>
                                                <td colSpan={24} className="bg-white text-center text-gray-500 text-sm py-2">
                                                    Sin cargo de pago registrado
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                                <tfoot>
                                    <tr className="font-bold text-[#14233a] border-0">
                                        <td colSpan="10" className="border-0 bg-transparent"></td>
                                        <td className="bg-yellow-200 py-1 px-2 text-center border border-gray-300">
                                            {formatoSoles(totalImporteNeto)}
                                        </td>
                                        <td colSpan={(canEstadoPago || canReciboHonorarios) ? 12 : 11} className="border-0 bg-transparent"></td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                    )}
                    <ModalEstadoPago
                        isOpen={state.modalEstadoPago}
                    />
                    <ModalEstadoPagoCargoPago
                        isOpen={estadoPagoModal}
                        onClose={() => { setEstadoPagoModal(false); setSelectedItemEstado(null); }}
                        onRefresh={getCargoPago}
                        item={selectedItemEstado}
                        periodo={periodo_fecha}
                    />
                    <ModalReciboHonorariosCargoPago
                        isOpen={reciboModal}
                        onClose={() => { setReciboModal(false); setSelectedItemRecibo(null); }}
                        onRefresh={getCargoPago}
                        item={selectedItemRecibo}
                        periodo={periodo_fecha}
                    />
                    <ModalRegistroCargoPago
                        isOpen={modalRegistroManual}
                        toggle={() => setModalRegistroManual(false)}
                        onSaveSuccess={getCargoPago}
                        periodo={periodo_fecha}
                    />
                </>)}
        </div>
    );
}

export default CargoPago;